import React from 'react';
import VisionMission from '../components/about/VisionMission';
import Timeline from '../components/about/Timeline';
import CoreTechnologies from '../components/about/CoreTechnologies';

/**
 * About Page
 * Displays company vision, mission, history, and core technologies
 */
const About = () => {
  return (
    <div className="min-h-screen">
      {/* Vision & Mission Section - Blue gradient background */}
      <VisionMission />

      {/* Timeline Section - Gray background */}
      <Timeline />

      {/* Core Technologies Section - White background */}
      <CoreTechnologies />
    </div>
  );
};

export default About;
